import styled from 'styled-components';
import { ShopContainer } from '~/components/ui/Shop';
import panelGlow from '../../assets/images/panel_glow.png';

const StyledShopContainer = styled(ShopContainer)`
	width: 640px;
	height: 840px;
	padding: 29px 29px 20px;
	background-image: url(${panelGlow});
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-origin: border-box;
`;

const StyledControlsContainer = styled.div`
	position: absolute;
	left: 0;
	bottom: 80px;
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 0 80px;
`;

const StyledRightContainer = styled.div`
	position: absolute;
	top: 80px;
	right: 80px;
	display: flex;
	gap: 40px;
`;

const StyledCloseButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 10px;
	background-color: #111314;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		transition: filter 0.3s ease;
		pointer-events: none;
		user-select: none;
	}
`;

export {
	StyledCloseButtonContainer,
	StyledControlsContainer,
	StyledRightContainer,
	StyledShopContainer,
};
